
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField } from '@material-ui/core';
import React from 'react';

const SearchComponent = ({
  searchByNDCID,
  setSearchByNDCID,
  searchOnEnter,
  onChange,
  className = '',
  error = '',
}) => {
  return (
    <div
      className={`mui-custom-form with-select d-flex flex-column justify-content-center align-items-start ${className}`}
    >
      <TextField
        label="Enter NDC to be Added"
        fullWidth
        required
        placeholder="XXXXX-XXXX-XX"
        id="enter_ndc_to_be_added"
        inputProps={{ maxlength: 13 }}
        InputLabelProps={{
          shrink: true,
        }}
        value={searchByNDCID}
        onKeyDown={(e) => {
          if (e.key === 'Enter') searchOnEnter();
        }}
        onChange={(e) => {
          if (onChange) {
            onChange(e);
          } else {
            if (/^[0-9-]+$/g.test(e.target.value)) {
              setSearchByNDCID(e.target.value);
            } else if (e.target.value === '') {
              setSearchByNDCID('');
            }
          }
        }}
      />
      {error && <div className="danger-text">{error}</div>}
    </div>
  );
};

export default SearchComponent;
